import React from "react";
import Component from "components";
import Banner from "./banner";
import About from "./about";
import Videos from "./videos";
import Vision from "./vision";
import Mision from "./mision";
import Testimonial from "./testimonial";
import Divider from "./divider";
import "assets/styles/home.less";

const Home : React.FC = () => {

    return (
       <Component.Publiclayout>
           <section className={"home-wrapper"}>
               <Banner />
               <Divider />
               <About />
               <Videos />
               <Vision />
               <Divider/>
               <Mision />
               <Divider/>
               <Testimonial />
           </section>
       </Component.Publiclayout>
    )
}

export default Home;